let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2yIG2")).then(() => parcelRequire('kd0Kz'));